import { memo, ReactElement, useMemo } from 'react';
import { FloatFilterDTO } from '../../../api/generated';
import { FilterChipProps } from './common';
import { ScaledNumberRangeFilterProps } from '../Primitives/ScaledNumberRangeFilter';
import { skipUndefined } from '../../../utils';
import { NumberRangeFilterChip } from './NumberRangeFilterChip';

export const ScaledNumberRangeFilterChip = memo(function ({
  value,
  factor = 1,
  ...restProps
}: FilterChipProps<ScaledNumberRangeFilterProps>): ReactElement {
  const scaledValue: FloatFilterDTO = useMemo(
    () => ({
      range: {
        gte: skipUndefined(value?.range?.gte, (v) => v / factor),
        lte: skipUndefined(value?.range?.lte, (v) => v / factor),
      },
    }),
    [value, factor]
  );

  return <NumberRangeFilterChip {...restProps} value={scaledValue} />;
});
